import update from "./update.js";
import getActiveId from "./getActiveId.js";

export default { update, getActiveId };
